import { render, staticRenderFns } from "./link-company.vue?vue&type=template&id=93fb0344&"
import script from "./link-company.vue?vue&type=script&lang=js&"
export * from "./link-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports